<style>
    .clearfix:after {
        content: '';
        display: block;
        visibility: hidden;
        clear: both;
    }

    .select-container {
        padding: 15px 2% 3px;
    }

    .select-left {
        float: left;
        display: table;
    }

    .select-left > div {
        vertical-align: top;
    }

    .select-left > div:not(:last-child) {
        margin-right: 5px;
    }

    .select-right {
        float: right;
    }
</style>

<template>
    <div>
        <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
            <span style="font-size:30px;font-weight:bold;">终端安全不合规</span><br><br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-weight:bold;color:red">同学你好，你的PC终端安全不合规</span>。为规范我公司办公网计算机风险威胁防范工作，保证办公网络和办公信息系统的安全稳定运行，
            特推广落实终端安全管理解决方案，请务必保证PC终端已安装和运行赛门铁克杀毒软件、数据防泄漏客户端（DLP）和美团安全管理客户端（MOA），
            请根据以下步骤进行检查终端不合规的详细原因并进行修复。<br>
            <span style="font-size:15px;font-weight:bold;">1、打开MOA客户端页面，点击“安全基线检查”按钮；</span><br><br>
            a.windows打开MOA客户端方法，如下图所示单击以下图标；<br>
            <img src="../assets/terminalIllegal/terminalIllegal_pic01.png" width=500px height=150px><br>
            在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。<br>
            <img src="../assets/terminalIllegal/terminalIllegal_pic02.png" width=600px height=400px><br>
            b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。<br>
            <img src="../assets/terminalIllegal/terminalIllegal_pic03.png" width=600px height=400px><br>
            <span style="font-size:15px;font-weight:bold;">2、排查“安全基线检查”。</span><br>
            <img src="../assets/terminalIllegal/terminalIllegal_pic04.png" width=800px height=500px><br><br>
            a.赛门铁克杀毒软件已安装 显示红色
            <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px>
            ，表示赛门铁克杀毒软件未安装，请从此处进入
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/saimenInstallForWin')">杀软安装指南—Windows</span>，
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/saimenInstallForMac')">杀软安装指南--macOS</span>。<br>
            b.数据防泄漏客户端已安装 显示红色
            <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px>
            ，表示数据防泄漏客户端未安装，请从此处进入
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/dataLeakInstallForWin')">DLP安装指南--Windows</span>，
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/dataLeakInstallForMac')">DLP安装指南--macOS</span>。<br>
            c.赛门铁克杀毒软件已运行 显示红色
            <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px>
            ，表示数据防泄漏客户端未安装，请从此处进入
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/windowRepairUnstart')">杀软安装指南—Windows</span>，
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/macRepairUnstart')">杀软安装指南--macOS</span>。<br>
            d.数据防泄漏客户端已运行 显示红色
            <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px>
            ，表示数据防泄漏客户端未安装，请从此处进入
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/dataLeakInstallForWin')">DLP安装指南--Windows</span>，
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/dataLeakInstallForMac')">DLP安装指南--macOS</span>。<br>
            <br><br>
            <span style="font-size:15px;font-weight:bold;">3、以上提示的红色修复完成后，请重新登录应用系统，如还有问题，请大象联系6000</span><br>
            a.如遇特殊情紧急情况，员工可申请临时白名单，申请页面请从此进入
            <span style="color:#63B8FF;text-decoration:underline;cursor:pointer"
                  @click="routerUrl('/whiteApply')">临时白名单</span>

        </div>
    </div>
</template>

<script>
    import store from '../vuex/service/store'
    import {mapState} from 'vuex';
    import util from '../views/util/commonUtil'

    export default {
        store: store,
        mounted: function () {
        },
        computed: mapState({
            loginRediret: function (state) {
                return state.loginRediret;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            }
        }),
        filters: {
            idcExplain(val) {
                return util.idcExplain(val)
            },
            timeFormat(val) {
                return util.timeFormat(val)
            },
            switchColor(val) {
                return util.switchColor(val)
            },
            statusExplain(val) {
                return util.statusExplain(val)
            }
        },
        methods: {
            reset() {

            },
            kmUrl(URL) {
                window.open(URL);
            },
            routerUrl(URL) {
                this.$router.push(URL)
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        vm.$message.error("401:您未登录");
                        var count = vm.getCookie("access-count")
                        window.location = vm.loginRediret;
                        if (count == null || count == 0) {
                            document.cookie = "access-count=1";
                            vm.$message('您未登录,请刷新');
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        } else {
                            vm.$message('您未登录,请刷新');
                        }
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'

                    });
                }
            }
        }
    }
</script>
<style>
    .select1 {
        width: 100px;
    }

    .select2 {
        width: 130px;
    }

    .select3 {
        width: 160px;
    }

    .input1 {
        width: 350px;
    }

    .input2 {
        width: 210px;
    }

    .demo-table-expand label {
        width: 140px;
        color: #5d94bf;
    }
</style>



// WEBPACK FOOTER //
// terminalIllegal.vue?abcd3c90